import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {AppService} from '../../../../services/app.service';
import {NavigationEnd, Router, RouterEvent} from '@angular/router';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-most-loved-brands',
  templateUrl: './most-loved-brands.component.html',
  styleUrls: ['./most-loved-brands.component.css']
})
export class MostLovedBrandsComponent implements OnInit {
  responseReceived = false;
  brands = [];

  constructor(
    private http: HttpClient,
    public appService: AppService,
    private router: Router
  ) {
  }

  ngOnInit(): void {

    this.router.events.pipe(
      filter((event: RouterEvent) => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.getBrands();
    });

    this.getBrands();
  }

  getBrands(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    this.http.get<any>(environment.domain + '/api/' + this.appService.getCurrentCity().toLowerCase() + '/most-loved-brands', httpOptions).subscribe(
      data => {
        if (data.type === 'success') {
          this.brands = data.data;
          this.responseReceived = true;
        }
      },
      error => {
        console.error('There was an error!', error);
      });
  }

}
